import { render, staticRenderFns } from "./CustomerSearchParametersEditor.vue?vue&type=template&id=8988b288&"
import script from "./CustomerSearchParametersEditor.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchParametersEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports